export const stringChunker = (
  splitArray: string[],
  chunk: number = 10,
): string[][] => {
  const tempArray: string[][] = [];
  for (let i = 0, j = splitArray.length; i < j; i += chunk) {
    tempArray.push(splitArray.slice(i, i + chunk));
  }
  return tempArray;
};

export const convertToParagraph = (text: string): string => {
  const description = text.split(' ');
  const stringChunks = stringChunker(description);
  let paragraph = '';
  stringChunks.forEach((chunk) => {
    const sentence = chunk.join(' ') + '\r\n';
    paragraph += sentence;
  });
  return paragraph.trim();
};
export const isNumeric = (value: string) => new RegExp('^[0-9]*$').test(value);
export const stringToHash = (text: string): number => {
  let hash = 0;
  let char = 0;
  if (text.length == 0) return hash;

  for (let i = 0; i < text.length; i++) {
    char = text.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }

  return hash;
};
